import React from 'react'
import { useStatusOverlay, Separator, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import PillButton from './PillButton'

export default function ArchiveActionsButtons() {
  const showStatusOverlay = useStatusOverlay()
  const [t] = useTranslation()
  return (
    <>
      <Separator size="xs" />
      <Row gutters="md">
        <PillButton
          emphasis="medium"
          onClick={() => {
            showStatusOverlay({
              message: 'TODO: Send request to Brightspot to reuse session.',
              type: 'warning',
            })
          }}
        >
          {t('dashboard.past-sessions.reuse-button', 'Reuse in 2026')}
        </PillButton>
        <PillButton
          emphasis="low"
          color="blue"
          onClick={() => {
            showStatusOverlay({
              message: 'TODO: Send request to Brightspot to archive session.',
              type: 'warning',
            })
          }}
        >
          {t('dashboard.past-sessions.archive-button', 'Archive')}
        </PillButton>
      </Row>
    </>
  )
}
